export const API_URL = "https://forkify-api.herokuapp.com/api/v2/recipes/";
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = `9df9d0e2-928e-4fce-b0b1-2f15f3920990`;
export const MODEL_CLOSE_SEC = 2.5;